/**
 * A mapping between parent height tokens to standardized child height tokens.
 */ const heightToContentHeight = {
    '2xs': '2xs',
    xs: 'xs',
    sm: 'xs',
    md: 'xs',
    lg: 'sm',
    xl: 'md',
    '2xl': 'md'
};

export { heightToContentHeight };
//# sourceMappingURL=height-to-content-height.js.map
